const state = {
  events: [],
  loading_events: null,
  limit_page_events: true,
  current_page: 1,
};

const mutations = {
  UPDATE_EVENTS(state, events) {
    state.events = events;
  },
  SET_LOADING_EVENTS(state, loading_events) {
    state.loading_events = loading_events;
  },
  LIMIT_PAGE_EVENTS(state, limit_page_events) {
    state.limit_page_events = limit_page_events;
  },
  SET_CURRENT_EVENT_PAGE(state, current_page) {
    state.current_page = current_page;
  },
};

const getters = {
  getEvents: (state) => {
    return state.events;
  },
  loadingStateEvents: (state) => {
    return state.loading_events;
  },
  getLimitPageEvents: (state) => {
    return state.limit_page_events;
  },
  getCurrentPageEvents: (state) => {
    return state.current_page;
  },
};

export default {
  state,
  mutations,
  getters,
};
